import { Action } from "@reduxjs/toolkit";
import { AdminInitialState } from "./types";

const initialState: AdminInitialState = {};

export function AdminReducer(state = initialState, action: Action) {
  return state;
}
